import React, { useState, useEffect } from "react";
import { CircularProgress, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import axios from "axios";

import { basePath } from "../../util/basePath";
import { useSelector, useDispatch } from "react-redux";
import { login, logout } from "../../redux/logger/logActions";
import { useNavigate } from "react-router-dom";
import { ErrorOutlineOutlined } from "@mui/icons-material";

const OauthLogin = () => {
  const queryparams = new URLSearchParams(window.location.search);

  const [loading, setLoading] = useState(false);

  const [loginData, setLoginData] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  // const name = queryparams.get("userName");
  // const email = queryparams.get("userEmail");
  // const token = queryparams.get("token");
  // const userId = queryparams.get("userId");

  const baseUrl = `${basePath.url}auth/login-oauth`;
  const dispatch = useDispatch();
  const logger = useSelector((state) => {
    return state.logger;
  });

  const navigate = useNavigate();
  useEffect(() => {
    // console.log(queryparams);

    if (queryparams) {
      setLoading(true);
      setLoginError(null);
      setFeedback(null);
      const name = queryparams.get("userName");
      const email = queryparams.get("userEmail");
      const token = queryparams.get("token");
      const userId = queryparams.get("userId");
      const data = { name, email, token, userId };
      setLoading(true);
      // alert(name);
      axios
        .post(baseUrl, data)
        .then((result) => {
          if (result.data.message === "success") {
            // const user = {
            //   userId: result.data.user.id,
            //   name: result.data.user.name,
            //   email: result.data.user.email,
            //   mobileNo: result.data.user?.mobileNo,
            // };

            dispatch(login(result.data.user));

            setFeedback("login Success");
            setLoading(false);
            setLoginError(null);

            navigate("/");
          } else {
            setLoading(false);
            setLoginError(result.data.description);
          }
        })
        .catch((err) => {
          setLoading(false);
          setLoginError(err.message);
        });
      // setLoading(false);
      // navigate("/");
    }
  }, []);

  return (
    <>
      <div
        className="fullWidthWrapper"
        style={{
          backgroundColor: "#fff",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            padding: 50,
            boxSizing: "border-box",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {loginError && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <ErrorOutlineOutlined style={{ fontSize: 50 }} color="warning" />
              <Typography
                variant="subtitle1"
                style={{ color: "crimson", fontSize: "14px", fontWeight: 400 }}
              >
                {loginError && <p>{loginError}</p>}
              </Typography>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              gap: 5,
            }}
          >
            {loading ? (
              // <CircularProgress size="large" color="success" />
              <span>
                <CircularProgress />
                <Typography variant="subtitle2">Loading...</Typography>
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default OauthLogin;
